import { toast } from "@/hooks/use-toast";
import { useTranslation } from "@/hooks/use-translation";
import { useAdminStore } from "@/store/useAdminStore";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useHandleGetOffer() {
   const { validateForm, handleSubmit, currentProduct } = useAdminStore();
   const { getValues } = useFormContext();
   const navigate = useNavigate();
   const { isIcelandic } = useTranslation();

   const handleGetOffer = async () => {
      if (!currentProduct) return;

      try {
         // Step 1: Validate the form
         const validationResult = validateForm();

         if (!validationResult.success) {
            // Show validation errors
            toast({
               title: "Please check your form",
               description: "There are validation errors that need to be fixed",
               variant: "destructive",
            });
            return;
         }

         // Step 2: Show success message and navigate immediately
         toast({
            title: "Form validated successfully!",
            description:
               "We will send you an email with the order details shortly",
         });
         navigate("/thank-you");

         // Step 3: Submit the data in the background
         const values = getValues();
         handleSubmit(values, isIcelandic).catch((error) => {
            console.error("Background submission failed:", error);
            // Could potentially show another toast here for submission failure
            // but user is already on thank you page
         });
      } catch (error) {
         console.error("Error in handleGetOffer:", error);
         toast({
            title: "Error processing form",
            description: "Please try again",
            variant: "destructive",
         });
      }
   };

   return { handleGetOffer };
}
